import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menu: [],
  },
  mutations: {
    SET_MENU(state, data) {
      state.menu = data;
    },
  },
  actions: {
    setMenu({ commit }, data) {
      commit('SET_MENU', data);
    },
  },
  modules: {
  },
});
